export const storage = {
  set: (key: string, value: Object) => {
    localStorage.setItem(key, JSON.stringify(value));
  },

  get: (key: string) => {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  },

  remove: (key: string) => {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  },
};
